import { Box, Typography } from '@mui/material'
import { DensityStyleTypes } from '../../../types'

interface ChildNoValueCellProps {
  densityStyles: DensityStyleTypes
}

const ChildNoValueCell = ({ densityStyles }: ChildNoValueCellProps): React.ReactElement => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <Typography
        sx={{
          fontSize: densityStyles.fontSize,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        {'—'}
      </Typography>
    </Box>
  )
}
export default ChildNoValueCell
